import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { API } from '@/api';

const AUTH_COOKIE_ONLY = String(process.env.REACT_APP_AUTH_COOKIE_ONLY || '').toLowerCase() === 'true';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Evitar doble ejecución en StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/');
      return;
    }
    const session_id = match[1];

    const exchangeSession = async () => {
      try {
        const { data } = await axios.post(`${API}/auth/google`, { session_id });
        const { _token, ...user } = data;
        if (_token && !AUTH_COOKIE_ONLY) {
          try { sessionStorage.setItem('elrc_token', _token); } catch { /* ignore */ }
        }
        setUser(user);
        // Limpiar el hash de la URL e ir al inicio
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/auth', { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0A0A0E] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#10B981]/30 border-t-[#10B981] rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#A1A1AA] text-sm">Iniciando sesión...</p>
      </div>
    </div>
  );
}
